var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.07552C2 7.97142 2.00788 7.86853 2.0232 7.76758L10.423 13.7214C11.3699 14.3925 12.6301 14.3925 13.577 13.7214L21.9768 7.76758C21.9921 7.86853 22 7.97142 22 8.07552V18.9748C22 20.0933 21.1046 21 20 21H4C2.89543 21 2 20.0933 2 18.9748V8.07552Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79395 6.45987C2.89062 6.38589 2.99475 6.32022 3.10554 6.26413L4.25453 5.68241C4.31973 4.76391 5.07627 4.03927 5.99997 4.03927H7.49997L11.1056 2.2138C11.6686 1.92873 12.3314 1.92873 12.8944 2.2138L16.5 4.03927H18C18.9237 4.03927 19.6802 4.76391 19.7454 5.68241L20.8944 6.26413C21.0052 6.32022 21.1093 6.38589 21.206 6.45987L18.25 8.55511V5.81152C18.25 5.67171 18.1381 5.55837 18 5.55837H5.99997C5.8619 5.55837 5.74997 5.67171 5.74997 5.81152V8.55507L2.79395 6.45987Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.84926C14 9.96773 13.1046 10.8744 12 10.8744C10.8954 10.8744 10 9.96773 10 8.84926C10 7.73079 10.8954 6.8241 12 6.8241C13.1046 6.8241 14 7.73079 14 8.84926Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyEnvelope);
export default __webpack_public_path__ + "static/media/money-envelope.512b4461c57c01662b678f1b6ae1cdce.svg";
export { ForwardRef as ReactComponent };